import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { ID_WIDTH, NAME_MIN_WIDTH } from '@barboxx/admin-utils';
import { PourAvailability } from '@barboxx/models';
import { POUR_AVAILABILITY_ENTITY_TYPE } from '@barboxx/types';
import { enumToFormOptions } from '@barboxx/utils';

const COLUMNS: GridColDef<PourAvailability.DetailsResponse>[] = [
    {
        field: 'id',
        headerName: 'Id',
        width: ID_WIDTH,
    },

    {
        field: 'pourFormat.pourType.name',
        headerName: 'Pour Type',
        minWidth: NAME_MIN_WIDTH,
        valueGetter: dataGridNestedObjectValueGetter,
        flex: 1,
        sortable: false,
    },

    {
        field: 'pourFormat.servingContainer.name',
        headerName: 'Serving Container',
        minWidth: NAME_MIN_WIDTH,
        valueGetter: (value, row) => {
            return (
                row?.pourFormat?.servingContainer?.name ||
                row.pourFormat.packagingFormat?.name
            );
        },
        flex: 1,
        sortable: false,
    },

    {
        field: 'name',
        headerName: 'Name',
        minWidth: NAME_MIN_WIDTH,
        valueGetter: (value, row) => {
            switch (row.entityType) {
                case 'ProductType':
                    return row?.productType?.name;
                case 'ProductSubtype':
                    return row?.productType?.name;
                case 'Category':
                    return row?.category?.name;
                case 'Drink':
                    return row?.standardDrink?.name;
                case 'ProductLine':
                    return row?.productLine?.name;
                case 'Product':
                    return row?.product?.name;
            }
        },
        sortable: false,
    },

    {
        field: 'entityType',
        headerName: 'Entity Type',
        minWidth: NAME_MIN_WIDTH,
        type: 'singleSelect',
        valueOptions: enumToFormOptions(POUR_AVAILABILITY_ENTITY_TYPE),
    },
    {
        field: 'displayOrder',
        headerName: 'Display Order',
        minWidth: NAME_MIN_WIDTH,
    },
    {
        field: 'isDefault',
        headerName: 'Is Default',
        minWidth: NAME_MIN_WIDTH,
        type: 'boolean',
    },
];

interface Props {
    data: PourAvailability[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function PourAvailabilityTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Pour Availability">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
